/**
 * Rental entity — rentals.Rental (xsite/rentals/models.py, serializers.py).
 */

import { createResourceApi } from '../shared/resourceApi';
import { createResourceHooks } from '../shared/createResourceHooks';
import type { Currency } from '../shared/types';

export interface RentalItem {
  id: number;
  stock_item?: number | null;
  stock_item_product?: number | null;
  stock_item_product_name?: string | null;
  quantity: number;
  tariff_quantity?: number | null;
  tariff_type?: string | null;
  tariff_price?: number | string | null;
  total_price?: number | string | null;
  return_status?: string;
  quantity_returned?: number;
  quantity_damaged?: number;
  quantity_lost?: number;
  quantity_stolen?: number;
  quantity_pending?: number;
  is_fully_returned?: boolean;
}

export interface Rental {
  id: number;
  customer?: number | null;
  customer_name?: string | null;
  customer_details?: { resp_person?: string; company_name?: string } | null;
  date_from: string;
  date_to: string;
  price?: number | string | null;
  discount_percentage?: number | string | null;
  rental_status: string;
  rental_status_display?: string;
  rental_reason_name?: string | null;
  rental_reason_details?: { name?: string } | null;
  issued_by_name?: string | null;
  issued_by_details?: { display_name?: string } | null;
  currency_detail?: Currency | null;
  // Detail-only: nested by RentalDetailSerializer
  rental_items?: RentalItem[];
}

export const rentalApi = createResourceApi<Rental>('rentals/api/rentals');

export const {
  keys: rentalKeys,
  useList: useRentals,
  useDetail: useRental,
  useCreate: useCreateRental,
  useUpdate: useUpdateRental,
  useRemove: useDeleteRental,
} = createResourceHooks(rentalApi, {
  name: 'rentals',
  model: 'rentals.rental',
  detailRelatedModels: ['rentals.rentalitem'],
});
